import type { ListType } from '../models/app';

export const serviceAccountTypeList: ListType[] = [
  { id: 1, key: 'all', label: 'All Accounts' },
  { id: 2, key: 'db', label: 'DB Accounts' },
  { id: 2, key: 'manual', label: 'Manual Accounts' },
];

/* Closed accounts are retired for good, so the tables default to hiding them. */
export const closedFilterList: ListType[] = [
  { id: 1, key: 'open', label: 'Open Only' },
  { id: 2, key: 'closed', label: 'Closed Only' },
  { id: 3, key: 'all', label: 'All' },
];

export const closedFilterToBoolean = (filter: string): boolean | null => {
  if (filter === 'open') {
    return false;
  }

  if (filter === 'closed') {
    return true;
  }

  return null;
};
